import { IconDefinition, faChartLine, faGear, faGears, faCoins } from '@fortawesome/free-solid-svg-icons';

interface IDashboardItemChild {
  href: string;
  title: string;
}

export interface IDashboardItem {
  href: string;
  title: string;
  badge?: number;
  icon?: IconDefinition;
  children?: IDashboardItemChild[];
  end?: boolean;
}

export const forecastSection: IDashboardItem = {
  href: '/forecast',
  icon: faChartLine,
  title: 'Sales Forecasting',
  children: [
    {
      href: '/forecast/dashboard',
      title: 'Dashboard',
    },

    {
      href: '/forecast/region',
      title: 'Regional Projection',
    },
    {
      href: '/forecast/brand',
      title: 'Brand Projection',
    },
    {
      href: '/forecast/top100',
      title: 'Top 100 Products',
    },
  ],
};
export const analysisSection: IDashboardItem = {
  href: '/analysis',
  icon: faGears,
  title: 'Analysis',
  children: [
    {
      href: '/analysis',
      title: 'Case and Revenue',
    },
  ],
};

export const adminSection = {
  href: '/admin',
  icon: faGear,
  title: 'Administration',
  children: [
    {
      href: '/admin/forecast',
      title: 'Projection',
    },
    {
      href: '/admin/product',
      title: 'Product',
      end: true,
    },
    {
      href: '/admin/price-calculator',
      title: 'Price Calculator',
    },
    {
      href: '/admin/product/price/state',
      title: 'Product Pricing',
    },
    {
      href: '/admin/user',
      title: 'User',
    },
    {
      href: '/admin/geography',
      title: 'Geography',
    },
    {
      href: '/admin/import-export',
      title: 'Import/Export',
    },
    {
      href: '/admin/brand',
      title: 'Brand',
    },
    {
      href: '/admin/fee',
      title: 'Fees',
    },
    {
      href: '/admin/bonuses',
      title: 'Bonuses',
    },
  ].sort((a, b) => a.title.localeCompare(b.title)),
};

export const salesBonusAdminSection = {
  href: '/bonuses',
  icon: faCoins,
  title: 'Bonuses',
  children: [
    {
      href: '/bonus/detail',
      title: 'My Bonuses',
    },
    {
      href: '/sales-bonus/upload',
      title: 'Data Upload',
    },
    // {
    //   href: '/sales-bonus/detail',
    //   title: 'Sales Bonus',
    // },
    {
      href: '/sales-commission/kpi-adjustment',
      title: 'KPI Adjustments',
    },
    {
      href: '/hd-bonus/submission',
      title: 'Health & Dev Bonus',
    },
  ],
};

export const priceAdminSection = {
  href: '/admin',
  icon: faGear,
  title: 'Administration',
  children: [
    {
      href: '/admin/product',
      title: 'Product',
      end: true,
    },
    {
      href: '/admin/price-calculator',
      title: 'Price Calculator',
    },
    {
      href: '/admin/product/price/state',
      title: 'Product Pricing',
    },
    {
      href: '/admin/fee',
      title: 'Fees',
    },
  ],
};

export const salesBonusSection = {
  href: '/bonuses',
  icon: faCoins,
  title: 'Bonuses',
  children: [
    {
      href: '/bonus/detail',
      title: 'My Bonuses',
    },
    // {
    //   href: '/sales-bonus/upload',
    //   title: 'Data Upload',
    // },
    // {
    //   href: '/sales-bonus/detail/:salesCompId',
    //   title: 'Sales Bonus',
    // },
    {
      href: '/sales-commission/kpi-adjustment',
      title: 'KPI Adjustments',
    },
    {
      href: '/hd-bonus/submission',
      title: 'Health & Dev Bonus',
    },
  ],
};

export const productUserSection = {
  href: '/admin',
  icon: faGear,
  title: 'Administration',
  children: [
    {
      href: '/admin/product',
      title: 'Product',
    },
  ],
};
